/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
export function isHTMLElement(x: unknown): x is HTMLElement {
  return x instanceof HTMLElement;
}
